// Persistent markers and notices: alerts off, PC unreachable, paused, removed, integration notices.
import type { ReactNode } from "react";
import { IconAlert, IconBellOff, IconClose, IconCloudOff, IconInfo, IconLock } from "./Icons";

export type BannerTone = "info" | "warn" | "danger" | "ok";
export type BannerIcon = "alert" | "bell-off" | "cloud-off" | "info" | "lock";

const ICONS: Record<BannerIcon, (p: { className?: string }) => JSX.Element> = {
  alert: IconAlert,
  "bell-off": IconBellOff,
  "cloud-off": IconCloudOff,
  info: IconInfo,
  lock: IconLock,
};

export function Banner({ tone = "info", icon = "info", title, children, action, onDismiss }: { tone?: BannerTone; icon?: BannerIcon; title: string; children?: ReactNode; action?: { label: string; onClick?: () => void; href?: string }; onDismiss?: () => void }) {
  const Icon = ICONS[icon];
  return (
    <div className={`banner ${tone === "info" ? "" : tone}`.trim()} role={tone === "danger" ? "alert" : "status"}>
      <Icon />
      <div className="body">
        <b>{title}</b>
        {children && <p>{children}</p>}
        {action && (action.href ? (
          <a className="link" href={action.href}>
            {action.label}
          </a>
        ) : (
          <button type="button" className="link" onClick={action.onClick}>
            {action.label}
          </button>
        ))}
      </div>
      {onDismiss && (
        <button type="button" className="dismiss" onClick={onDismiss} aria-label="Dismiss">
          <IconClose />
        </button>
      )}
    </div>
  );
}
